/* eslint-disable no-unused-vars */
import * as Yup from 'yup'

export const schemaProcessValidation = Yup.object({
  sku: Yup.string()
    .min(3, 'Debe ingresar a lo menos 3 caracteres')
    .max(50, 'El campo acepta como máximo 50 caracteres.')
    .required('Campo obligatorio.')
})

export const EnumProcessValidate = [
  {
    id: 1,
    name: 'CREADO',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'white',
    display: false
  },
  {
    id: 2,
    name: 'EN PROCESO',
    color: '#ffea00',
    btnName: 'btnEnProceso',
    textColor: 'black',
    display: false
  },
  {
    id: 3,
    name: 'FINALIZADO OK',
    color: '#4caf50',
    btnName: 'btnFinalizadoOK',
    textColor: 'black',
    display: true
  },
  {
    id: 4,
    name: 'FINALIZADO CON ERROR',
    color: '#f48fb1',
    btnName: 'btnFinalizadoConError',
    textColor: 'black',
    display: true
  }
]

export const EnumTypeProcessValidate = [
  {
    id: 1,
    name: 'CREACIÓN MASIVA OT',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 2,
    name: 'CREACIÓN MASIVA PICKING',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 3,
    name: 'CREACIÓN PACKING LIST',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 4,
    name: 'CREACIÓN INVENTARIO',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 5,
    name: 'CREACIÓN ORDEN INTERNA',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 6,
    name: 'CREACIÓN KARDEX',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 7,
    name: 'PROCESO MASIVO POSICIONES',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 8,
    name: 'PROCESO EXPORTACIÓN POSICIONES',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 9,
    name: 'RECEPCIÓN ASN MASIVA',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 10,
    name: 'CREACIÓN ORDEN DE MANTENCIÓN',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  },
  {
    id: 11,
    name: 'CREACIÓN ORDEN DE RECALL',
    color: '#2196f3',
    btnName: 'btnCreado',
    textColor: 'black'
  }
]
